import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getAllScreensFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.screenUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllScreensFromServer][Store][Error occured while getting screens List--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewScreen(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.screenUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewScreen][Store][screens add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewScreen][Store][Error occured while adding screens--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async updateExistingScreens(context, payload = {}) {
    //payload : {params:{ScreenId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.put(`${Constants.screenUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateExistingScreens][Store][Screen update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateExistingScreens][Store][Error occured while updating Screen--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteExistingScreen(context, payload = {}) {
    //payload : {params:{ScreenId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.delete(`${Constants.screenUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteExistingScreen][Store][Screen Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteExistingScreen][Store][Error occured while deleting Screen--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getScreenInfoFromServer(context, payload = {}) {
    //payload : {params:{ScreenId:"3422344231"}}

    try {
      let resp = await axios.get(`${Constants.screenUrl}/${payload.params._id}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getScreenInfoFromServer][Store][Error occured while getting Screen info --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
};
